import { createTheme, globalTheme } from '@cld/component-theme';

export const theme = createTheme({
  buttons: {
    margin: globalTheme.spacing.xs,
    padding: globalTheme.spacing.xxs,
  },
});
